import { usePage } from "@inertiajs/react";
import { useState, useEffect } from "react";
import classNames from "classnames";

export default function Switch({
  name,
  onChange,
  value,
  url,
}) {
  const [processing, setProcessing] = useState(false);
  const props = usePage().props;

  const handleChange = () => {
    // A record that isn't saved yet has nothing to PUT to: the new value lives
    // in the caller's state until whatever creates the record sends it along.
    if (!url) {
      if (typeof onChange === "function")
        onChange({ [name]: !value });

      return;
    }

    setProcessing(true);
    fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({ authenticity_token: props.csrf_token, [name]: !value }),
    }).then(async (response) => {
      if (typeof onChange === "function")
        onChange({ [name]: !value });

      setProcessing(false);
    });
  };

  return (
    <div
      className={classNames("inpt-switch", { "inpt-switch--checked": value })}
      onClick={handleChange}
      disabled={processing}
    >
      <div className="inpt-switch-tumbler"></div>
    </div>
  );
}
